/**
 * @generated SignedSource<<801decb57f2990786e19e1b8586b25d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeRuleShow_rule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeRuleTimeline_rule"
    }
  ],
  "type": "TradeRule",
  "abstractKey": null
};

node.hash = "a8dd46f77dfab2204f4ff33be344669a";

module.exports = node;
